if(!customElements.get('image-slider-custom')) {
  /**
  * @class
  * @function ImageSlider
  */
  class ImageSlider extends HTMLElement {

    //###################################################################//
    constructor() {
      super();

      // this.setSlider();
      // this.setupEvents();
      this.init();
      this.addEventListener('change', this.setupImageSlider());
      //this.addEventListener('click', (event) => { this.addSliderNavigationEvents(event) });
    }

    //###################################################################//
    connectedCallback() {
      this.section = this.closest('.shopify-section.section-image-slider');
      this.container = this.section.querySelector('.image-slider-custom--inner');
      this.sliderItems = this.querySelectorAll('.carousel__slide');
      
      // this.setSlider();
      // this.setupEvents();
      this.init();       
    }


    //###################################################################//
    setSlider() {
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        groupCells: false,
        initialIndex: 0,
        cellAlign: 'left',
        adaptiveHeight: true,
        cellSelector: '.carousel__slide',
        pageDots: true,
        prevNextButtons: false
      };

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.options.cellAlign = 'center';
      }
      
    }

    
    //###################################################################//
    init() {
      this.setSlider();
      this.flickity = new Flickity(this, this.options);      
      this.setupEvents();
    }   

    
    //###################################################################//
    reInit(...args) {
      this.flickity.destroy();
      
      this.setSlider();
      this.flickity = new Flickity(this, this.options);
      
      this.setupEvents();
    }

    
    //###################################################################//
    setupEvents() {
      if (this.prev_button) {
        this.prev_button.addEventListener('click', (event) => {
          this.flickity.previous();
        });
        this.prev_button.addEventListener('keyup', (event) => {
          this.flickity.previous();
          event.preventDefault();
        });
      }
      
      if (this.next_button) {        
        this.next_button.addEventListener('click', (event) => {
          this.flickity.next();
        });
        this.next_button.addEventListener('keyup', (event) => {
          this.flickity.next();
          event.preventDefault();
        });
      }
    }

    
    //###################################################################//
    selectCell(mediaId) {
      this.flickity.selectCell(mediaId);
    }

    
    //###################################################################//
    setupImageSlider() {
      if (!this.querySelectorAll('.slider-item__zoom').length) return;
      this.setEventListeners();
    }


    //###################################################################//
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.carousel__slide img'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);
        let activelink = item.closest('.carousel__slide').querySelector('.slider-item__zoom');

        //activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    

    //###################################################################//
    setEventListeners() {
      this.section = this.closest('.section-image-slider');
      this.links = this.querySelectorAll('.slider-item__zoom');
      this.pswpElement = this.section.querySelector('.pswp');

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.carousel__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };
      
      //this.links.forEach((link) => {
        // link.addEventListener('click', (e) => {
        //   this.flickity.select(e.target.dataset.index, false, false);
        //   this.zoomClick(e, link);
       //});
      //});
      let _this = this;
      this.links.forEach((link) => {      
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      });
      
      this.flickity.on('staticClick', function(event,cellElement,cellIndex) {
        event.preventDefault();
        _this.zoomClick(event, event.target);
      });  
        
        
     
      

      // let _this = this;
      // this.flickity.on('staticClick', function(event,cellElement,cellIndex) {
      //   event.preventDefault();
      //   //alert(cellElement.innerHTML);
      //   _this.zoomClick(event, event.target);
      // });      
    }


    //###################################################################//
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      //this.pswpOptions.index = parseInt(index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }

   
    
  } //END CLASS  
  customElements.define('image-slider-custom', ImageSlider);
}